import React, {forwardRef,  useImperativeHandle, useRef, useState} from "react";
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {TT_CLOSE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {FORM} from "../../../../components/i18n/i18n";
import {GenericButton} from "../../../../components/buttons/customButtons";
import Separator from "../../../../components/Separator";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {scheduleService} from "../../../../jwt/_services/clasificator/scheduleService";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {typeSeasonProvider} from "../../../../providers/typeSeasonProvider";



// components

// labels

// actions

// services

// providers


export const ActivityScheduleSectionForm = forwardRef((props, ref) => {
    const path = props.path ;
    const [app] = useState(props.app || null);
    const [activity] = useState(props.activity || null);

    const [domainObject, setDomainObject] = useState(null);


    const [typeSeasonId, setTypeSeasonId] = useState(null);
    const [status, setStatus] = useState( null)
    const [time12, setTime12] = useState(domainObject?.time12 || null);
    const [time24, setTime24] = useState(domainObject?.time24 || null);
    const [duration, setDuration] = useState(domainObject?.duration || '')
    const [timeFrom, setTimeFrom] = useState('00:00');
    const [timeTo, setTimeTo] = useState('00:00');
    const [errors, setErrors] = useState({});


    const [modal, setModal] = useState(false);

    const [showHistoryModal, setShowHistoryModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalRef.current.showModal(domainObject);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item) {
            if (_item?.id !== undefined) {
                setDomainObject(_item);
                setStatus(_item?.status );
                setDuration( _item?.duration );
                setTime12(_item?.time12);
                setTime24(_item?.time24);
                setTypeSeasonId(_item?.typeSeason?.id || null);

                if (_item?.time24 !== null) {
                    separateFromTo(_item?.time24);
                    if (!(!!_item?.id)) {
                        setSchedule(timeFrom, timeTo)
                    }
                }
            } else {
                setDomainObject(null);
                setStatus(true);
                setDuration('');
                setTimeFrom(null);
                setTimeTo(null);
                setTime12(null);
                setTime24(null);
                setTypeSeasonId(null);
            }
            setModal(!modal);
        }
    }));


    const validationSchema = Yup.object().shape({
    });

    const {register, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            duration: domainObject?.duration,
            time12: domainObject?.time12,
            time24: domainObject?.time24,
        }
    });

    const validateSubmit = () => {
        let _errors = {}

        if (timeFrom === null)
            _errors.timeFrom = true;

        if (typeSeasonId == null)
            _errors.typeSeason = true;

        setErrors(_errors);
        return !(_errors.timeFrom || _errors.typeSeason);
    }

    const onSubmit = (_) => {
        if (!validateSubmit())
            return;

        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                time12: time12,
                time24: time24,
                status: status,
                duration : duration,
                activity : { id: activity?.id },
                typeSeason: { id: typeSeasonId },
            }
        };

        // console.log(dataRequest);
        // return;

        if (domainObject?.id !== undefined) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, scheduleService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, scheduleService, dataRequest)
        }

        closeModal();
    };

    const confirmDelete = () => {
        genericIndexedActions.delete(path, scheduleService, domainObject?.id, app?.fbDataBase?.id)
    }

    const separateFromTo = (time) => {
        if (time !== undefined) {
            const _timeFrom = time.split('-')[0].trim();
            const _timeTo = time.split('-')[1]?.trim() !== undefined ? time.split('-')[1]?.trim() : null;

            setTimeFrom(_timeFrom);
            setTimeTo(_timeTo);

            if (_timeTo !== null)
                setDuration(calcularDiferenciaHoras(_timeFrom, _timeTo));
        }
    }

    const setSchedule = (from, to) => {
        if (from === undefined || from === null) {
            return
        }

        let from12;
        let to12;

        // From values
        const fromh24 = from.split(':')[0];
        const fromm24 = from.split(':')[1];
        if (fromh24 >= 12) {
            from12 = fromh24 === "12" ? `12:${fromm24} PM` : `${fromh24 - 12}:${fromm24} PM`;
        } else {
            from12 = `${fromh24}:${fromm24} AM`;
        }

        // To values
        if (to !== undefined && to !== null) {
            let toh24 = to.split(':')[0];
            let tom24 = to.split(':')[1];
            if (fromh24 > toh24 || (fromh24 === toh24 && fromm24 > tom24)) {
                to = from;

                toh24 = to.split(':')[0];
                tom24 = to.split(':')[1];
                setTimeTo(to);
            }

            if (toh24 >= 12) {
                to12 = toh24 === "12" ? `12:${tom24} PM` : `${toh24 - 12}:${tom24} PM`;
            } else {
                to12 = `${toh24}:${tom24} AM`;
            }
        }

        if (from === to || to === undefined || to === null ) {
            setTime24(`${from}`);
            setTime12(`${from12}`);
        } else {
            setTime24(`${from} - ${to}`);
            setTime12(`${from12} - ${to12}`);
        }
    }

    function calcularDiferenciaHoras(horaInicial, horaFinal) {
        if (horaInicial === undefined || horaFinal === undefined || horaInicial === null || horaFinal === null) {
            return duration
        }

        // Convertir las cadenas de hora en minutos desde la medianoche
        const [horaInicio, minutoInicio] = horaInicial.split(':').map(Number);
        const [horaFin, minutoFin] = horaFinal.split(':').map(Number);

        const minutosInicio = horaInicio * 60 + minutoInicio;
        const minutosFin = horaFin * 60 + minutoFin;

        // Calcular la diferencia en minutos
        let diferenciaMinutos = minutosFin - minutosInicio;

        // Asegurarse de que la diferencia sea positiva y esté en un ciclo de 24 horas
        if (diferenciaMinutos < 0) {
            diferenciaMinutos += 1440; // 24 horas en minutos
        }

        // Calcular horas y minutos
        const horas = Math.floor(diferenciaMinutos / 60);
        const minutos = diferenciaMinutos % 60;

        // Crear una cadena de resultado formateada
        let resultado = '';

        if (horas > 0) {
            resultado += horas === 1 ? '1 hr' : `${horas} hrs`;
        }

        if (minutos > 0) {
            if (resultado.length > 0) {
                resultado += ' ';
            }
            resultado += minutos === 1 ? '1 min' : `${minutos} min`;
        }

        return resultado;
    }

    const onTimeFromChange = (value) => {
        setTimeFrom(value);
        setSchedule(value, timeTo);
        setDuration(calcularDiferenciaHoras(value,timeTo ));
    }

    const onTimeToChange = (value) => {
        setTimeTo(value);
        setSchedule(timeFrom, value);
        setDuration(calcularDiferenciaHoras(timeFrom, value));
    }

    const closeModal = () => {
        setModal(!modal);
        setDuration('');
        setTimeFrom('00:00');
        setTimeTo('00:00');
        setStatus(null);
        setDomainObject(null);
        setTypeSeasonId(null);
        reset();
    }

    const showModal = () => {
        setModal(!modal);
    }

    return <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0 modal-title">
                <i className="far fa-edit mr-2"/>{FORM}
                <br/>
                <h5 className={'card-modal-uid'}> {'     uid: ' + (domainObject?.uid || '')}</h5>
                <div className="top-right">
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={onSubmit}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeModal}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className={(errors.timeFrom ? 'label-is-invalid' : '')} >Desde </Label>
                            <Input type="time" name="timeFrom"
                                   placeholder="Ingrese hora"
                                   innerRef={register}
                                   value={timeFrom}
                                   onChange={e => onTimeFromChange(e.target.value)}
                                   className={(errors.timeFrom ? ' is-invalid' : '')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label >Hasta </Label>
                            <Input type="time" name="timeTo"
                                   placeholder="Ingrese hora"
                                   innerRef={register}
                                   value={timeTo}
                                   onChange={e => onTimeToChange(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="5">
                        <FormGroup>
                            <Label className={(errors.typeSeason ? 'label-is-invalid' : '')}>Tipo de temporada</Label>
                            <SelectGeneric
                                initialValue={ typeSeasonId || null }
                                hasError={ errors.typeSeason }
                                setExternalValue={ setTypeSeasonId }
                                provider = { typeSeasonProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="5">
                        <FormGroup>
                            <Label>Duración</Label>
                            <Input type="text"
                                   name="duration"
                                   placeholder="Ingrese duración"
                                   value={ duration }
                                   onChange={e => setDuration(e.target.value)}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Activo</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </Modal>
})
